import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analyticsTrends';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_TEST_TRENDS = createApiNamespacedConstants('GET_TEST_TRENDS');
export const GET_TEST_ERRORS = createApiNamespacedConstants('GET_TEST_ERRORS');
export const GET_BUILDS_TESTS = createApiNamespacedConstants('GET_BUILDS_TESTS');
export const GET_TESTS = createApiNamespacedConstants('GET_TESTS');
export const GET_TESTS_BY_BUILD = createApiNamespacedConstants('GET_TESTS_BY_BUILD');
export const SET_CURRENT_PAGE = `${NAMESPACE}/SET_CURRENT_PAGE`;
export const SET_STATUS_FILTER = `${NAMESPACE}/SET_STATUS_FILTER`;
export const SET_TESTS_BY_BUILD = `${NAMESPACE}/SET_TESTS_BY_BUILD`;
export const CLEAN_UP = `${NAMESPACE}/CLEAN_UP`;
